module.exports = __webpack_public_path__ + "img/user_01.808ed2d4.jpg";